// extracted by mini-css-extract-plugin
module.exports = {"gstNotice":"_19LyD"};